export enum KnmPublishStatusesEnum {
  ASK_TO_PUBLISH = 'ASK_TO_PUBLISH',
  ASK_TO_UNPUBLISH = 'ASK_TO_UNPUBLISH',
  PUBLISHED = 'PUBLISHED',
  PUBLISH = 'PUBLISH',
  UNPUBLISHED = 'UNPUBLISHED',
}
